import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { RoleListLayer } from '../components/roles/RoleListLayer'

export const RoleListPage = () => {
  return (
    <MasterLayout>
        <RoleListLayer />
    </MasterLayout>
  )
}
